var clone;

var cloneObject = function(obj, deep) {
  var ret = {};
  var keys = Object.keys(obj);
  var i;
  for (i = 0; i < keys.length; i++) {
    ret[keys[i]] = deep ? clone(obj[keys[i]], deep) : obj[keys[i]];
  }

  return(ret);
};

var cloneArray = function(arr, deep) {
  var ret = [];
  var i;
  for (i = 0; i < arr.length; i++) {
    ret.push(deep ? clone(arr[i], deep) : arr[i]);
  }

  return(ret);
};

clone = function(obj, deep) {
  if (!obj) return(obj);
  if (typeof(obj) !== 'object') return(obj);
  if (Array.isArray(obj)) {
    return(cloneArray(obj, deep));
  } else {
    return(cloneObject(obj, deep));
  }
};

module.exports = clone;
module.exports.array = cloneArray;
module.exports.object = cloneObject;



/** WEBPACK FOOTER **
 ** ./src/Api/clone.js
 **/